import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface CreateDataExtractionReportParams {
	data_extraction_id: string;
	organization_id: string;
	company_id: string;
	reports: {
		report_type?: string;
		custom_report_id?: string | null;
		bera_report_id?: string | null;
		sera_report_id?: string | null;
	}[];
}

const Service = DataExtractionService.getInstance();

export const useCreateDataExtractionReport = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateDataExtractionReportParams) => Service.createDataExtractionReport(params),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_CUSTOM_REPORT_BY_TYPE_LIST] });
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_DATA_EXTRACTION_SELECTED_REPORTS_COUNT] });
			message.success(I18n.get('The report has been successfully added to the data extraction'));
		},
		onError: () => {
			message.error(I18n.get('Failed to add the report to the data extraction'));
		}
	});
};
